import {Button, Grid} from '@material-ui/core'
import React from 'react'
import SignaturePad from 'react-signature-canvas'
import handleNotfication from '../../utils/handleNotification'
import styles from './styles.module.scss'
import BundleRepository from 'client-sdk/src/Repository/bundles-repository'
import {useHistory} from 'react-router-dom'
import handleError from '../../utils/handleError';
import { UpdateBundleStatusRequestBuilder } from 'client-sdk/src/bundles/bundle'
import updateEntranceStatus from '../../requests/updateEntranceStatus'


function Signature(props:any) {
  let sigPad:any = null
  const {id,vehicleId, entranceId} = props.match.params
  const history = useHistory();

  const clear = () => {
    sigPad.clear()
  }

  const assign = async () => {
    if(sigPad?.isEmpty()) {
      handleNotfication('امضا اجباری است', 'error')
    }else {
      // console.log(sigPad)
      const data = sigPad.getTrimmedCanvas().toDataURL('image/png')
      const blob = new Blob([data],{type: 'image/png'})
      let formData = new FormData();
      formData.append('signature', blob);
      const payload = {
        id, 
        params: {vehicleId},
        data: formData
      }
      
      const statUpdatePayload = {
        payload: {
        id, 
        body: '"LOADED"',
        }
      }

      const entranceUpdatePayload = {
        description: `Changing status of entrance id ${id}`,
        ids: [parseInt(entranceId)],
        status: "LOADED",
      }

      try {
        await BundleRepository.assignBundleToVehicleWithSignature({payload});
        await updateEntranceStatus(entranceUpdatePayload);
        await BundleRepository.updateBundleStatus(statUpdatePayload);
        
        handleNotfication(`مرسوله ${id} تخصیص داده شد.`, 'success')
        history.push('/bundles-deliver')
      }catch(err:any) {
        handleError(err.response)
      }
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.sigContainer}>
        <SignaturePad canvasProps={{className: styles.sigPad}}
          ref={(ref) => { sigPad = ref }} />
      </div>
      {/* <div>
        <button className={styles.buttons} onClick={clear}>
          Clear
        </button>
        <button className={styles.buttons} onClick={trim}>
          Trim
        </button>
      </div> */}
      <Grid className={styles.bottomBox}>
        <Button
          style={{ flex: "1 0 0" }}
          size="large"
          onClick={assign}
          variant="contained"
          color="primary"
        >
          تاییدوتحویل
        </Button>
        <Button
          style={{ marginRight: '10px', flex: "1 0 0" }}
          size="large"
          onClick={clear}
          variant="outlined"
          color="primary"
        >
          پاک کردن صفحه
        </Button>
      </Grid>
      {/* {trimmedDataURL
        ? <img className={styles.sigImage}
          src={trimmedDataURL} />
        : null} */}
    </div>
  )
}

export default Signature
